import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { isCypressTest, isDev } from "../environment";
import { HVA_TIERS, type HvaEventName } from "./hva-events";

// Mirrors the subset of LoggingUser in ../datadog that logHva reads. Not
// imported from there directly to keep this module's typecheck scope
// narrow — see b56ef1b1 history for the attempt that pulled the whole
// datadog init chain into shadcn-ui's tsc.
type HvaUserContext = {
  brand_id?: number;
  brand_name?: string;
};

export function logHva(event: HvaEventName, properties?: Record<string, unknown>): void {
  // Ship HVAs from production and staging. Dev (localhost) and cypress
  // runs are gated off so we don't pay ingestion for every filter/sort
  // click during development. RUM session logs are unaffected.
  if (isDev() || isCypressTest()) return;

  const sessionId = datadogRum.getInternalContext()?.session_id ?? null;

  // Nest `brand` the same way the BE emits it so dashboard filters on
  // @brand.name / @brand.id work uniformly across FE and BE events. @usr.*
  // is already attached globally by datadogLogs.setUser(user) in
  // DataDogManager.updateUserInfo so we don't need to re-emit it here.
  // datadogLogs.getUser() returns a generic Context dict; narrowing to
  // the brand fields we care about.
  const user = datadogLogs.getUser() as HvaUserContext | undefined;
  const brand = user?.brand_id != null && user.brand_name != null ? { id: user.brand_id, name: user.brand_name } : null;

  datadogLogs.logger.info(`hva.${event}`, {
    event_category: "hva",
    event,
    tier: HVA_TIERS[event],
    session_id: sessionId,
    brand,
    properties: properties ?? null
  });
}

export function getHvaSessionId(): string | null {
  return datadogRum.getInternalContext()?.session_id ?? null;
}
